import {EPaymentTab} from './definitions';

export default {
  yourBalance: 'Your account balance is',
  tab: {
    [EPaymentTab.REPLENISHMENT]: 'Balance replenishment',
    [EPaymentTab.ACCOUNT_STATEMENT]: 'Account statement',
    [EPaymentTab.DOCUMENTATION]: 'Documents',
  },
};
